"use client"; // Error components must be Client Components

import { useEffect } from "react";
import ErrorComponent from "@components/ErrorComponent/ErrorComponent";

const Error = ({ error, reset, eventId="" }) => {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);
  const isApp = eventId === "oTUU8jWihKTfhOEIcpN8" || eventId === "df36rQaooLrjUmWGNAzP";
  const message =  isApp? "You have to download the app, click on the event link and click on “Open” to see the event." : "This event was cancelled";
  return <ErrorComponent errorMsg={message} />;
};

export default Error;
